/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import GLRconcilationDashboard from '../../components/GLP2PAdvComp/GLReconcilationDashboard';
import GLChartRepresentation from '../../components/GLP2PAdvComp/GLChartRepresentation';
import TabSwitcher from '../../components/FileUploadComp/TabSwitcher/TabSwitcher';
import styles from './GLReconPage.module.css';


const GLReconPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
  const history = useHistory();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);


  const [selectedTab, setSelectedTab] = useState('Advance GL Ageing Trend');

  const availableTabs = ['Advance GL Ageing Trend', 'Advance GL Ageing Summary Report'];

  const handleBack = () => {
    history.push("/Procure-To-Pay/Account-Payable");
  };

  return (
    <div className={styles.container}>
      <div className={styles.container}>
      {/* <TabSwitcher
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        tabs={availableTabs}
      /> */}
      <div className={styles.tabHeader}>
        <TabSwitcher
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabs={availableTabs}
        />

        <button className={styles.backButton} onClick={handleBack}>
          ← Back
        </button>
      </div>
      {selectedTab === 'Advance GL Ageing Trend' ? (
        <GLChartRepresentation />
      ) : selectedTab === 'Advance GL Ageing Summary Report' ? (
        <GLRconcilationDashboard />
      ) : null}
    </div>
    </div>
  )
}

GLReconPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(GLReconPage);
